import { AdvisorResponse } from "../models/ProviderInfo";
import axios, { AxiosResponse } from "axios";
import { HISTORY_API_DOMAIN, P_CHAIN_INDEXER_DOMAIN } from "../constants";
import { NodesList } from "../models/Node";
import { ValidatorsInfo } from "../models/Validator";
import { ValidatorListResponse, TransactionResponse, AddressPairResponse, StakedTransactionResponse } from "../models/Response";
import { AddressPair } from "../models/AddressPair";
import { StakedTransactions } from "../models/StakedTransaction";

export class AdvisorService {
  static async getDataProvidersInfo(): Promise<AdvisorResponse> {
    const response: AxiosResponse<AdvisorResponse> = await axios.get(
      `${HISTORY_API_DOMAIN}history/advisor/advise`
    );
    return response.data;
  }

  static async getNodes(): Promise<NodesList> {
    const response: AxiosResponse<NodesList> = await axios.get(
      `${HISTORY_API_DOMAIN}history/pchain/nodes`
    );
    return response.data;
  }

  static async getValidatorList(): Promise<ValidatorsInfo> {
    const response: AxiosResponse<ValidatorListResponse> = await axios.get(
      `${P_CHAIN_INDEXER_DOMAIN}validators/listValidators`
    );
    return response.data.data;
  }

  static async getAddressPair(address: string): Promise<AddressPair> {
    const response: AxiosResponse<AddressPairResponse> = await axios.get(
      `${P_CHAIN_INDEXER_DOMAIN}misc/addresses/${address}`
    );
    return response.data.data;
  }

  static async getStakedTransactions(address: string): Promise<StakedTransactions> {
    const response: AxiosResponse<StakedTransactionResponse> = await axios.get(
      `${P_CHAIN_INDEXER_DOMAIN}state/balance/${address}`);
    return response.data.data;
  }
}
